// extracted by mini-css-extract-plugin
export default {"introduction":"Banner_introduction__jJ4y4"};